import React, { useState } from "react"
import * as S from "./menu-items-layout.styles"
import MenuItems from "../../components/menu-items/menu-items.component"
import Container from "@mui/material/Container"
import { graphql, useStaticQuery } from "gatsby"
import CustomButton from "../../components/custom-button/custom-button.component"
import parse from "html-react-parser"

const MenuItemsLayout = ({ buttonLink }) => {
  const staticQuery = useStaticQuery(graphql`
    query {
      allWpMenuHtpb(sort: { order: DESC, fields: date }) {
        nodes {
          id
          title
          menuFields {
            bottomInfo
            items {
              description
              name
              price
            }
          }
        }
      }
    }
  `)

  const menu = staticQuery.allWpMenuHtpb.nodes

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [title, setTitle] = useState("Calzone")

  const handleMenuChange = (index, currentTitle) => {
    setSelectedIndex(index)
    setTitle(currentTitle)
  }

  if (!menu || !menu.length) return null

  return (
    <>
      <S.Background>
        {/*<S.ButtonWrapperRight>*/}
        {/*  {buttonLink && buttonLink.url && (*/}
        {/*    <CustomButton href={buttonLink.url} target="_blank" className="red">*/}
        {/*      {buttonLink.title}*/}
        {/*    </CustomButton>*/}
        {/*  )}*/}
        {/*</S.ButtonWrapperRight>*/}
        <S.Tabs container justify="center">
          <S.TabsContainer>
            {menu.map(({ title }, index) => (
              <a
                className={selectedIndex === index ? "active" : ""}
                onClick={() => handleMenuChange(index, title)}
                key={`menuItems-${index}`}
              >
                {title}
              </a>
            ))}
          </S.TabsContainer>
        </S.Tabs>
      </S.Background>
      <S.BackgroundMenu>
        <Container maxWidth="lg">
          <S.ButtonWrapperCenter>
            <CustomButton className="red">{title}</CustomButton>
          </S.ButtonWrapperCenter>
          <S.Columns container spacing={8}>
            {menu
              .slice(selectedIndex, selectedIndex + 1)
              .map(
                ({ menuFields }) =>
                  menuFields.items &&
                  menuFields.items.length > 0 &&
                  menuFields.items.map(
                    ({ name, price, description }, index) => (
                      <MenuItems
                        key={`menu-item-${index}`}
                        name={name}
                        price={price}
                        description={description}
                        index={index}
                      />
                    )
                  )
              )}
          </S.Columns>
          {menu
            .slice(selectedIndex, selectedIndex + 1)
            .map(({ menuFields }, index) => (
              <S.Text key={`text-${index}`}>
                {menuFields.bottomInfo && parse(menuFields.bottomInfo)}
              </S.Text>
            ))}
        </Container>
      </S.BackgroundMenu>
    </>
  )
}

export default MenuItemsLayout
